/*
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-11-27 19:30:38
 * @LastEditors  : 侯鹏许(houpengxu@qq.com)
 * @LastEditTime : 2020-01-04 14:52:57
 * @Description: file content
 * 
 */
export default {
  protocol: 'https:',
  domain: 'henduoke.ttrushi.com/qc-webapp/wxapi.do',
  action: {
    paymentUrl: "/pay/WXPayAction/paymentUrl"
  }
}